export default {
  methods: {
    embedCode(config, src) {
      const configuration = config || this.configuration
      const widgetSrc = src || this.widgetSrc

      let embedCode = ''
      let configString = ''

      configString += `data-widget-token="${configuration.widgetToken}"\n`

      embedCode = `<script id="gb_widget_script"
        type="module"
        src="${widgetSrc}"
        ${configString.trim()}></script>`

      return embedCode
    }
  }
}
